export default {
  placeholder: 'Todos',
  selectAllLabel: 'Todos',
  all: 'Todos',
  filtered: 'filtrado',
  filteredPlural: 'filtrados',
  negated: 'negativado',
  negatedPlural: 'negativados',
};
